import { toolRegistryApi } from '@/apis';

export default {
  async initToolRegistryDashboard({ commit, dispatch }) {
    commit('reset');
    commit('setLoading', true);
    const requests = [dispatch('fetchList'), dispatch('fetchSummary')];
    await Promise.all(requests);
    commit('setLoading', false);
  },
  async incrementTools({ commit, dispatch }) {
    commit('setAdding', true);
    await dispatch('fetchList');
    commit('setAdding', false);
  },
  async fetchList({ commit }) {
    try {
      const response = await toolRegistryApi.requestList();
      commit('addTools', response.data.tools);
      commit('setPaging', response.data.paging);
    } catch (error) {
      commit('setError', error);
    }
  },
  async fetchSummary({ commit }) {
    try {
      const response = await toolRegistryApi.requestSummary();
      commit('setSummary', response.data);
    } catch (error) {
      commit('setError', error);
    }
  },
};
